import React, { FC, useCallback } from 'react';
import { mapIndexed } from '../../../../../utils/array';
import { useMMGRSettings } from '../../../../../utils/hoc/withMMGRSettings';
import { Section } from './Section';
import { IOuter } from './SectionsLayout.types';
import styles from './SectionsLayout.scss';

export const SectionsLayout: FC<IOuter> = ({
  dataHook,
  sections,
  rowsInSection,
  isItemSelected,
  onItemClick,
  onShowAllClick,
  beginDrag,
  alwaysShowAction,
  onFolderDoubleClick,
  onFileDoubleClick,
  openExpandedView,
  onItemRightClick,
  selectedItems,
  buyItem,
  hasSelectedItems,
  currentFolder,
}) => {
  const { mmgrSettings } = useMMGRSettings();
  const isSecure = mmgrSettings.isSecureContext;

  const handleShowAllClick = useCallback((sectionIndex) => () => onShowAllClick(sectionIndex), [onShowAllClick]);

  return (
    <div className={styles.wrapper} data-hook={dataHook}>
      {mapIndexed(
        ({ sectionName, title, data, action }, index) => (
          <Section
            beginDrag={beginDrag}
            isSecure={isSecure}
            isItemSelected={isItemSelected}
            selectedItems={selectedItems}
            hasSelectedItems={hasSelectedItems}
            onItemClick={onItemClick}
            onItemRightClick={onItemRightClick}
            sectionName={sectionName}
            key={sectionName}
            title={title}
            items={data}
            action={action}
            maxRowsToShow={rowsInSection}
            onShowAllClick={handleShowAllClick(index)}
            onFileDoubleClick={onFileDoubleClick}
            onFolderDoubleClick={onFolderDoubleClick}
            alwaysShowAction={alwaysShowAction}
            openExpandedView={openExpandedView}
            buyItem={buyItem}
            currentFolder={currentFolder}
          />
        ),
        sections,
      )}
    </div>
  );
};
